export const getMoneyFormatter = (locale: string, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale, {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  ...options,
});

export const getPercentageFormatter = (locale: string, decimalDigits: number) => new Intl.NumberFormat(locale, {
  style: "percent",
  maximumFractionDigits: decimalDigits
});

export const getNumberFormatter = (locale: string) => new Intl.NumberFormat(locale);

export const formatUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
